import { __decorate } from "tslib";
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
let AiTaggingApiImpl = class AiTaggingApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: workspaceApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    getFieldsApi(params) {
        return this.get({
            url: `/auto-label/folder/${params.folder_id}/field`,
            transformCode: true,
            params: {
                global_flag: 'all',
                ..._.omit(params, 'folder_id'),
            },
        }).then(res => res.data);
    }
    postFolderFieldSettingsApi(params) {
        return this.post({
            url: `/space/${params.space_id}/folder/${params.folder_id}/field-setting`,
            data: {
                ..._.omit(params, ['space_id', 'folder_id']),
            },
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
    getNodesApi(folderId, fieldId) {
        return this.get({
            url: `/smart/folder/${folderId}/field/${fieldId}/summary`,
            transformCode: true,
        }).then(res => res.data);
    }
    parsingNodeApi(params) {
        return this.post({
            url: '/ai-node-desc',
            transformCode: true,
            data: {
                ...params,
            },
        }).then(res => res.data);
    }
    reParsingNodeApi(params) {
        return this.post({
            url: '/ai-node-desc/re-generate',
            transformCode: true,
            data: {
                ...params,
            },
        }).then(res => res.data);
    }
    updateNodeSummaryByNodeIdApi(params) {
        return this.put({
            url: `ai-node-desc/${params.node_id}`,
            transformCode: true,
            data: {
                ...params,
            },
        }).then(res => res.data);
    }
    startTaggingApi(taggingParams) {
        return this.post({
            url: '/smart/custom/field/label',
            data: {
                ...taggingParams,
            },
            transformCode: true,
        }).then(res => res.data);
    }
    startMaxTaggingApi(taggingParams) {
        return this.post({
            url: '/smart/custom/field/label',
            data: {
                ...taggingParams,
            },
            transformCode: true,
        }).then(res => res.data);
    }
    getTaggingResultApi(params) {
        return this.post({
            url: '/smart/custom/field/label-status',
            data: {
                ...params,
            },
            transformCode: true,
        }).then(res => res.data);
    }
    cancelTaggingApi(params) {
        return this.post({
            url: '/smart/custom/field/label-cancel',
            data: params,
            transformCode: true,
        }).then(res => res.data);
    }
};
AiTaggingApiImpl = __decorate([
    injectable()
], AiTaggingApiImpl);
export { AiTaggingApiImpl };
